import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BodyBoldS, BodyRegularS } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';

export interface IColor {
  theme: ITheme;
  color?: string;
}

export const TileCont = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 1px 0;
  
  ${({theme}: IThemeProvider) => `
    padding: ${theme.layout.spacing.mikro} ${theme.layout.spacing.centy};
    background: ${theme.colors.neutral.primary[0]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[30]};
  `}

  &:hover {
    ${({theme}: IThemeProvider) => `
      background: ${theme.colors.primary[10]};
    `}
  }
`;

export const GroupInfoCont = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
  ${({theme}: IThemeProvider) => `
    @media ${theme.layout.breakpoints.min.desktop} {
    }
  `}
`;

interface ITeamName {
  isKpiAvailable: boolean;
  isRiskAvailable: boolean;
  theme: ITheme;
}

const teamNameWidth = (isKpiAvailable: boolean, isRiskAvailable: boolean, breakPoint: 'min' | 'max') => {
  let width;
  if(!isKpiAvailable && !isRiskAvailable){
    width = breakPoint === 'min' ? '478px' : '270px';
  }
  else if(isKpiAvailable && isRiskAvailable){
    width = breakPoint === 'min' ? '185px': '90px';
  }
  else {
    width = breakPoint === 'min' ? '330px' : '200px';
  }
  return width;
};

export const TeamName = styled(BodyRegularS)<ITeamName>`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  justify-self: flex-start;
  margin: 0 auto 0 0;
  ${({isRiskAvailable, isKpiAvailable, theme}: ITeamName) => `
    @media ${theme.layout.breakpoints.min.desktop} {
      max-width: ${teamNameWidth(isKpiAvailable, isRiskAvailable, 'min')};
      min-width: 185px;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      max-width: ${teamNameWidth(isKpiAvailable, isRiskAvailable, 'max')};
      min-width: 90px;
    }
  `}
`;

export const ResponseRateCont = styled.div`
  width: 114px;
  text-align: center;
  ${({theme}: IThemeProvider) => `
    @media ${theme.layout.breakpoints.min.desktop} {
      margin: 0 30px 0 0;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      margin: 0 10px 0 0;
    }
  `}
`;

export const ResponseRate = styled(BodyBoldS)<IColor>`
  ${({color}: IColor) => `
    color: ${color};
  `}
`;

export const ResponseCount = styled(BodyRegularS)`
  ${({theme}: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
    margin: 0 0 0 ${theme.layout.spacing.nano};
  `}
`;

export const Risk = styled(BodyBoldS)<IColor>`
  text-transform: capitalize;
  width: 88px;
  text-align: center;
  ${({color, theme}: IColor) => `
    color: ${color};
    @media ${theme.layout.breakpoints.min.desktop} {
      margin: 0 40px 0 0;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      margin: 0 15px 0 0;
    }
  `}
`;

export const Score = styled(BodyBoldS)`
  ${({theme}: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[0]};
  `}
`;

export const KpiCont = styled.div<IColor>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({color, theme}: IColor) => `
    width: ${theme.layout.spacing.mega};
    height: ${theme.layout.spacing.mega};
    background: ${color};
    border-radius: ${theme.layout.spacing.giga};
    @media ${theme.layout.breakpoints.min.desktop} {
      margin: 0 38px 0 0;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      margin: 0 10px 0 0;
    }
  `}
`;

export const CategoryResultCont = styled.div<IColor>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 152px;
  margin-left: 8px;
  ${({color, theme}: IColor) => `
    min-width: 40px;
    height: ${theme.layout.spacing.mega};
    background: ${color};
    border-radius: ${theme.layout.spacing.piko};
  `}
`;

interface IReportLink {
  theme: ITheme;
  isTeamReportAvailable: boolean;
}

export const ReportLink = styled.div<IReportLink>`
  ${({theme, isTeamReportAvailable}: IReportLink) => `
    background: ${isTeamReportAvailable ? theme.colors.neutral.primary[0] : 'transparent'};
    border-radius: ${theme.layout.spacing.mikro};
    width: ${theme.layout.spacing.mega};
    height: ${theme.layout.spacing.mega};
    @media ${theme.layout.breakpoints.min.desktop} {
      margin-left: 42px;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      margin-left: 20px;
    }
    a {

    cursor: ${isTeamReportAvailable ? 'pointer' : 'default'};
    }
  `}
`;

export const LinkCont = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;